<div class="pagination selenium-pagination" *ngIf="count > 0">
    <div class="numbers selenium-pagination-numbers">
        <button
            class="selenium-pagination-first"
            *ngIf="!simplePagination"
            (click)="onFirst()"
            [disabled]="page === 1 || loading"
            [ngClass]="{ disabled: page === 1 || loading }"
        >
            First
        </button>
        <button
            class="selenium-pagination-prev"
            *ngIf="!simplePagination || count > pagesToShow"
            (click)="onPrev()"
            [disabled]="page === 1 || loading"
            [ngClass]="{ disabled: page === 1 || loading }"
        >
            <app-icon class="arrow popover-arrow" [type]="'Arrow-left'"></app-icon>
        </button>

        <button
            *ngFor="let pageNum of getPages()"
            (click)="onPage(pageNum)"
            class="selenium-page-{{ pageNum }} page-{{ pageNum }}"
            [ngClass]="{ active: pageNum === page, disabled: loading }"
            [disabled]="loading"
        >
            <span class="number">{{ pageNum }}</span>
        </button>
        <button
            class="selenium-pagination-next"
            *ngIf="!simplePagination || count > pagesToShow"
            (click)="onNext()"
            [disabled]="lastPage() || loading"
            [ngClass]="{ disabled: lastPage() || loading }"
        >
            <app-icon class="arrow popover-arrow" [type]="'Arrow-right'"></app-icon>
        </button>
        <button
            class="selenium-pagination-last"
            *ngIf="!simplePagination"
            (click)="onLast()"
            [disabled]="lastPage() || loading"
            [ngClass]="{ disabled: lastPage() || loading }"
        >
            Last
        </button>
    </div>
</div>
